module.exports = __webpack_public_path__ + "static/media/Logo.92bdcbf1.png";